import { getSubdomain } from "app/utils/generic.helper";

export const isProd = () => process.env.NODE_ENV === "production";
export const Mixpanel = {
  identify: (id) => {
    if (isProd()) return `identify:${id}`;
    return "identify:user123";
  },
  alias: (id) => {
    if (isProd()) return `alias:${id}`;
    return "alias:user123";
  },
  track: (name, props = {}) => {
    if (isProd()) {
      const platform = getSubdomain();
      return { name, ...props, Platform: platform };
    }
    return { Platform: "demo-platform", name: "Click", page: "Home" };
  },

  people: {
    set: (props = {}) => {
      if (isProd()) return { ...props, synced: true };
      return { email: "alice@test.com", name: "Alice", synced: true };
    },
  },
};
